import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Box, Button, Flex, Text } from '@chakra-ui/react';

import Header from '../../components/Header';
import Modal from '../../components/Modal';
import loginBackground from '../../loginBackground.png';
import { createErrorToast, createSuccessToast } from '../../redux/modules/app';
import { selectNavExpanded, toggleNavBar } from '../../redux/modules/navbar';
import { useMeData } from '../../services/user-service';

import PinsAdminImports from './imports/PinsAdminImports';
import PinsAdminCompaniesTable from './PinsAdminCompaniesTable';
import PinsAdminEmailLogsTable from './PinsAdminEmailLogsTable';
import PinsAdminNavBar from './PinsAdminNavBar';
import PinsAdminUsersTable from './PinsAdminUsersTable';

const PinsAdminPage = () => {
  const dispatch = useDispatch();
  const isNavExpanded = useSelector(selectNavExpanded);

  const { data: user, isLoading: userIsLoading, status } = useMeData();

  useEffect(() => () => {
    if (user && user?.userLevel !== 1) {
      dispatch(createErrorToast({ title: 'You are not authorized to view this page' }));

      window.location.href = '/logout';
    }
  }, [user, userIsLoading, status]);

  const handleLogout = () => {
    window.location.href = '/logout';

    dispatch(createSuccessToast({ title: 'Logging out...' }));
  };

  if (userIsLoading) {
    return (
      <Box
        alignItems="center"
        backgroundImage={loginBackground}
        backgroundPosition="center"
        backgroundSize="cover"
        display="flex"
        h="100vh"
        justifyContent="center"
        w="100vw"
      >
        <Text>Loading...</Text>
      </Box>
    );
  }

  if (!userIsLoading && user?.userLevel !== 1) {
    return (
      <Box
        alignItems="center"
        backgroundImage={loginBackground}
        backgroundPosition="center"
        backgroundSize="cover"
        display="flex"
        h="100vh"
        justifyContent="center"
        w="100vw"
      >
        <Box>
          <Text mb={4}>You are not authorized to view this content.  If you are not redirected, click the button below.</Text>
          <Button onClick={() => window.location.replace('/v2/login')}>Back to Log In Page</Button>
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Box>
        <Header
          handleNavClick={() => dispatch(toggleNavBar())}
          isNavOpen={isNavExpanded}
          logoLinkHref="/login"
        >
          <Button variant="secondary" onClick={handleLogout}>
            Logout
          </Button>
        </Header>
        <Flex width="100%">
          <PinsAdminNavBar />
          <Box flexBasis="100%" overflow="auto">
            <Switch>
              <Route component={PinsAdminCompaniesTable} path="/pinsadmin/companies" />
              <Route component={PinsAdminEmailLogsTable} path="/pinsadmin/email-logs" />
              <Route component={PinsAdminImports} path="/pinsadmin/imports" />
              <Route component={PinsAdminUsersTable} path="/pinsadmin/users" />
              <Redirect exact from="/pinsadmin" to="/pinsadmin/companies" />
            </Switch>
          </Box>
        </Flex>
      </Box>
      <Modal />
    </>
  );
};

PinsAdminPage.propTypes = {};

export default PinsAdminPage;
